import actions from './actions'

const initialState = {
  rooms: [],
  loading: false,
  ready: false,
}

export default function bookingsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
